export default __webpack_public_path__ + "static/media/femimed_poczekalnia_thumbnail.5540f421.webp";